import React, { useState, useMemo } from 'react'

import { ReactComponent as IconEdit } from 'assets/images/icons/edit-3.svg'
import FormDrawer from 'components/__new/common/form-drawer'
import DateFormat from 'utils/dateFormat';
import Maybe from 'components/__new/common/Maybe';
import { getRandomWholeNumber } from 'utils/generateUniqueId';
import { ViewPayrollConfigRow } from './ViewPayrollConfigRow';

const ViewPayStructureDetails = ({isOpen, setIsOpen, payStructure, loading, payStructureGroups, GroupColorsMap, handleToggleEditForm }) => {
    const [isOpenEditPayStructure, setIsOpenEditPayStructure] = useState(false);
    
    const customSalaryBreakdown = payStructure?.salary_breakdown?.filter(({ is_default }) => !is_default ).reduce((result, value, index, array) => {
        if (index % 2 === 0) {
          result.push([value, array[index + 1]]);
        }
        return result;
    }, []);
    
    const employeeCount = useMemo(() => {
        let employeeCount = 0;
                                            
        payStructureGroups.flat().forEach((payGroup) => {
            employeeCount += payGroup?.employees?.length;
        });
        return employeeCount;
    }, [payStructureGroups]);
    
    return (
        <>
            {/* <EditPayStructure
                isOpen={isOpenEditPayStructure}
                setIsOpen={setIsOpenEditPayStructure}
                benefit={benefit}
            /> */}
            
            <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen} backdropClickable={false}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Pay Structure"
                        // description="Setup a new approval workflow"
                        showCloseButton={true}
                        close={setIsOpen}
                    />
                    <hr className='mt-3'/>

                    <div className="w-full my-7">
                        <div className="my-7 flex items-center justify-end space-x-2 cursor-pointer text-ep-primary-600"
                            onClick={() => {
                                handleToggleEditForm();
                                setIsOpen(false);
                            }}
                        >
                            <IconEdit />
                            <span className='underline'>Edit Information</span>
                        </div>
                        
                        <div className='p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Pay Structure Information</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                <div className="flex flex-col gap-6">
                                    <ViewPayrollConfigRow
                                        leftLabel="Structure Name"
                                        leftValue={payStructure?.name}
                                        rightLabel="Number of Employees"
                                        rightValue={employeeCount}
                                    />
                                    <ViewPayrollConfigRow
                                        leftLabel="Date Created"
                                        leftValue={DateFormat(payStructure?.createdAt)}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <div className='my-5 p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Default Breakdown</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                <div className='flex gap-6'>
                                    <div className='flex flex-col gap-6 w-3/5'>
                                        {
                                            payStructure?.salary_breakdown?.filter(({ salary_component }) => salary_component === "BASIC")?.map((salaryBreakdown, index) => (
                                                <div key={index}>
                                                    <div className='text-[#718096]'>Basic</div>
                                                    <div>{salaryBreakdown?.percentage}%</div>
                                                </div>
                                            ))
                                        }
                                        {
                                            payStructure?.salary_breakdown?.filter(({ salary_component }) => salary_component === "TRANSPORT")?.map((salaryBreakdown, index) => (
                                                <div key={index}>
                                                    <div className='text-[#718096]'>Transport</div>
                                                    <div>{salaryBreakdown?.percentage}%</div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div className='flex flex-col gap-6 w-2/5'>
                                        {
                                            payStructure?.salary_breakdown?.filter(({ salary_component }) => salary_component === "HOUSING")?.map((salaryBreakdown, index) => (
                                                <div key={index}>
                                                    <div className='text-[#718096]'>Housing</div>
                                                    <div>{salaryBreakdown?.percentage}%</div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <Maybe condition={payStructure?.salary_breakdown?.find(({ is_default }) => !is_default) || false}>
                            <div className='my-5 p-2 rounded-xl border bg-ep-primary-light-300'>
                                <div className='font-medium text-[#374151] text-lg'>Custom Breakdown</div>
                                <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                    {
                                        customSalaryBreakdown?.length > 0 && (
                                            <div className="flex flex-col gap-6">
                                                {customSalaryBreakdown?.map((customBreakdown, index) => (
                                                    <div key={index}>
                                                        <ViewPayrollConfigRow 
                                                            leftLabel={customBreakdown?.[0]?.salary_component}
                                                            leftValue={`${customBreakdown?.[0]?.percentage}%`}
                                                            rightLabel={customBreakdown?.[1]?.salary_component || ""}
                                                            rightValue={`${customBreakdown?.[1] ? `${customBreakdown?.[1]?.percentage}%` : ""}`}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </Maybe>
                        
                        <Maybe condition={payStructureGroups.length > 0}>
                            <div className='my-5 p-2 rounded-xl border bg-ep-primary-light-300'>
                                <div className='font-medium text-[#374151] text-lg'>Assign to Groups</div>
                                <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                    <div className='flex gap-6'>
                                        {payStructureGroups?.length > 0 && payStructureGroups?.map((group, index) => {
                                            const num = getRandomWholeNumber(3);
                                            
                                            return (
                                                <div key={index}>
                                                    <div className={`rounded-full bg-[${GroupColorsMap[num]?.bg}] text-[${GroupColorsMap[num]?.color}] py-1 px-4`}>
                                                        {group?.name}  
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Maybe>
                        
                        <Maybe condition={payStructure?.deductions?.pension_deduction?.is_enabled || payStructure?.deductions?.nhf || payStructure?.deductions?.nsitf || payStructure?.deductions?.itf}>
                            <div className='my-5 p-2 rounded-xl border bg-ep-primary-light-300'>
                                <div className='font-medium text-[#374151] text-lg'>Statutory Deductions</div>
                                <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                    <div className='flex flex-wrap gap-6'>
                                        {
                                            payStructure?.deductions?.pension_deduction?.is_enabled && (
                                                <div className={`rounded-full bg-[${GroupColorsMap[0]?.bg}] text-[${GroupColorsMap[0]?.color}] py-1 px-4`}>
                                                    Pension
                                                </div>
                                            )
                                        }
                                        
                                        {
                                            payStructure?.deductions?.nhf && (
                                                <div className={`rounded-full bg-[${GroupColorsMap[0]?.bg}] text-[${GroupColorsMap[1]?.color}] py-1 px-4`}>
                                                    NHF
                                                </div>
                                            )
                                        }
                                        
                                        {
                                            payStructure?.deductions?.nsitf && (
                                                <div className={`rounded-full bg-[${GroupColorsMap[0]?.bg}] text-[${GroupColorsMap[2]?.color}] py-1 px-4`}>
                                                    NSITF
                                                </div>
                                            )
                                        }
                                        
                                        {
                                            payStructure?.deductions?.itf && (
                                                <div className={`rounded-full bg-[${GroupColorsMap[0]?.bg}] text-[${GroupColorsMap[0]?.color}] py-1 px-4`}>
                                                    ITF
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </Maybe>
                        <Maybe condition={payStructure?.deductions?.custom_deductions?.length > 0}>
                            <div className='my-5 p-2 rounded-xl border bg-ep-primary-light-300'>
                                <div className='font-medium text-[#374151] text-lg'>Custom Deductions</div>
                                <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow'>
                                    <div className='flex flex-wrap gap-6'>
                                        {
                                            payStructure?.deductions?.custom_deductions?.length > 0 && payStructure?.deductions?.custom_deductions?.map((deduction, index) => {
                                                const num = getRandomWholeNumber(3);
                                                
                                                return ( 
                                                    <div className={`rounded-full bg-[${GroupColorsMap[num]?.bg}] text-[${GroupColorsMap[num]?.color}] py-1 px-4 capitalize`} style={{ wordBreak: "break-all"}} key={index}>
                                                        {deduction?.name?.toLowerCase()}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </Maybe>
                    </div>
                </div>
            </FormDrawer>
        
        </>
    )
}



export default ViewPayStructureDetails;